import React from 'react';
import Experiment, {Off, On} from '@homeaway/react-experiment';
import Map from '../Map/Map';
import MapControl from '../MapControl/MapControl';
import {APP_NAMES} from '../../constants';

const MapWrapper = (props) => {
    const {apiConfigOptions} = props;
    switch (apiConfigOptions.appName) {
        case APP_NAMES.SERP:
            return (
                <Experiment name={'vrbo_eg_maps_adoption_serp'}>
                    <On>
                        <Map {...props} />
                    </On>
                    <Off>
                        <MapControl {...props} />
                    </Off>
                </Experiment>
            );
        case APP_NAMES.PDP:
            return (
                <Experiment name={'vrbo_eg_maps_adoption_pdp'}>
                    <On>
                        <Map {...props} />
                    </On>
                    <Off>
                        <MapControl {...props} />
                    </Off>
                </Experiment>
            );
        case APP_NAMES.LANDINGAPP:
            return (
                <Experiment name={'vrbo_eg_maps_adoption_lp'}>
                    <On>
                        <Map {...props} />
                    </On>
                    <Off>
                        <MapControl {...props} />
                    </Off>
                </Experiment>
            );
        case APP_NAMES.TRIPBOARDS:
            return (
                <Experiment name={'vrbo_eg_maps_adoption_tb'}>
                    <On>
                        <Map {...props} />
                    </On>
                    <Off>
                        <MapControl {...props} />
                    </Off>
                </Experiment>
            );
        case APP_NAMES.STAY_UI:
            return (
                <Experiment name={'vrbo_eg_maps_adoption_stay'}>
                    <On>
                        <Map {...props} />
                    </On>
                    <Off>
                        <MapControl {...props} />
                    </Off>
                </Experiment>
            );
        default:
            return <MapControl {...props} />;
    }
};

export default MapWrapper;
